import { gql } from "@apollo/client";
export const typeDef = gql`
  type Browser {
    major: Int
    name: String
    version: Float
  }

  type OS {
    major: Int
    name: String
    version: Float
  }

  type DeviceInfo @cacheControl(scope: PRIVATE, maxAge: 86400) {
    browser: Browser
    deviceType: String
    deviceVendor: String
    isAndroid: Boolean
    isBot: Boolean
    isChrome: Boolean
    isChromeOS: Boolean
    isDesktop: Boolean
    isEdge: Boolean
    isFirefox: Boolean
    isIE: Boolean
    isIOS: Boolean
    isIPad: Boolean
    isIPhone: Boolean
    isMac: Boolean
    isMobile: Boolean
    isSafari: Boolean
    isTablet: Boolean
    isWindows: Boolean
    os: OS
    ua: String
    isWebView: Boolean
    isApp: Boolean
  }

  type Query {
    deviceInfo: DeviceInfo
  }
`;
export const resolvers = {
  Query: {
    deviceInfo: async (_parent, _args, _ref) => {
      let {
        req
      } = _ref;
      return req.deviceInfo;
    }
  }
};